import { lazy } from 'react';
import { t } from 'helpers/i18n';

// App pages
const Home = lazy(() => import('containers/Home'));
const Cart = lazy(() =>
  import('containers/Cart').then(module => ({ default: module.Cart }))
);
const Order = lazy(() =>
  import('containers/Order').then(module => ({ default: module.Order }))
);

/*
 * If route has children, it's a parent menu (not link to any pages)
 * You can change permissions to your IAM's permissions
 */
const routes = [
  {
    exact: true,
    path: '/',
    name: t('Home'),
    component: Home,
  },
  {
    exact: true,
    path: '/cart',
    name: t('Cart'),
    component: Cart,
  },
  {
    exact: true,
    path: '/order',
    name: t('Order'),
    component: Order,
  },
];

export default routes;
